/* eslint-disable */
import Vue from 'vue'
import { bus } from '../../main';
var $ = window.jQuery = require('jquery');
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import {
  mapGetters
} from 'vuex';
export default {
  name: 'algo-task-two',
  components: {
    DatePicker
  },
  props: [],
  data () {
    return {
      file1:null,
      uploadFileName1: '',
      uploadingLoader3:false,
      submitted:false,
      filetype1:'KNN',
      resultData1:'',
      errMsgShow1:false,
      errMsg1:'',
      task1:'Breast cancer diagnosis for detecting benign or malignant tumors',
      taskEditAble1:true,
      attribute1: {
        forecast_key:'',
        forecast_val: '',
        forecast_label: ''
      },
      attributes1: [{
        forecast_key:'x1',
        forecast_val: '1',
        forecast_label: 'Radius mean'
      },{
        forecast_key:'x2',
        forecast_val: '0',
        forecast_label: 'Texture mean'
      },{
        forecast_key:'x3',
        forecast_val: '1',
        forecast_label: 'Perimeter mean'
      },{
        forecast_key:'x4',
        forecast_val: '1',
        forecast_label: 'Area mean'
      },{
        forecast_key:'x5',
        forecast_val: '0',
        forecast_label: 'Smoothness mean'
      },{
        forecast_key:'x6',
        forecast_val: '0',
        forecast_label: 'Compactness mean'
      },{
        forecast_key:'x7',
        forecast_val: '0',
        forecast_label: 'Concavity mean'
      },{
        forecast_key:'x8',
        forecast_val: '0',
        forecast_label: 'Concave Points mean'
      },{
        forecast_key:'x9',
        forecast_val: '0',
        forecast_label: 'Symmetry mean'
      },{
        forecast_key:'x10',
        forecast_val: '0',
        forecast_label: 'Fractal Dimention mean'
      },{
        forecast_key:'x11',
        forecast_val: '0',
        forecast_label: 'radius se'
      },{
        forecast_key:'x12',
        forecast_val: '0',
        forecast_label: 'texture se'
      },{
        forecast_key:'x13',
        forecast_val: '0',
        forecast_label: 'perimeter se'
      },{
        forecast_key:'x14',
        forecast_val: '0',
        forecast_label: 'area se'
      },{
        forecast_key:'x15',
        forecast_val: '0',
        forecast_label: 'smoothness se'
      },{
        forecast_key:'x16',
        forecast_val: '0',
        forecast_label: 'compactness se'
      },{
        forecast_key:'x17',
        forecast_val: '0',
        forecast_label: 'concavity se'
      },{
        forecast_key:'x18',
        forecast_val: '0',
        forecast_label: 'concave points se'
      },{
        forecast_key:'x19',
        forecast_val: '0',
        forecast_label: 'symmetry se'
      },{
        forecast_key:'x20',
        forecast_val: '0',
        forecast_label: 'fractal dimention se'
      },{
        forecast_key:'x21',
        forecast_val: '0',
        forecast_label: 'radius worst'
      },{
        forecast_key:'x22',
        forecast_val: '0',
        forecast_label: 'texture worst'
      },{
        forecast_key:'x23',
        forecast_val: '0',
        forecast_label: 'perimeter worst'
      },{
        forecast_key:'x24',
        forecast_val: '0',
        forecast_label: 'area worst'
      },{
        forecast_key:'x25',
        forecast_val: '0',
        forecast_label: 'smoothness worst'
      },{
        forecast_key:'x26',
        forecast_val: '0',
        forecast_label: 'compactness worst'
      },{
        forecast_key:'x27',
        forecast_val: '0',
        forecast_label: 'concavity worst'
      },{
        forecast_key:'x28',
        forecast_val: '0',
        forecast_label: 'concave points worst'
      },{
        forecast_key:'x29',
        forecast_val: '0',
        forecast_label: 'symmetry worst'
      },{
        forecast_key:'x30',
        forecast_val: '0',
        forecast_label: 'fractal dimention worst'
      }],
      my_features_data1 :[],
      my_feature_label1:{},
      response_data:'',
      first_name1:'',
      last_name1:'',
      patient_name1:'', 
      patient_age1:'', 
      patient_gender1:'',
      patient_id1:'',
      patient_date1:'',
      inputAttrList1:[],
      local_Array1: {
        forecast_val: '',
        key:'',
        value: ''
      },
      algorithm_loader1:false,
      features1:'30',
      task_number:'',
      userDetails:''
    }
  },
  computed: {
    ...mapGetters([
      'getInputAttrListGetters',
      'acUserDetailsStateGetters'
    ]),
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    // getInputAttrListed1Fun() {
    //   this.$store.dispatch('getInputAttrListFun',{id:2}).then((res) => {
    //   this.inputAttrList1 = this.$store.getters.getInputAttrListGetters.data
    //   if(this.inputAttrList1 && this.inputAttrList1.length >= 1){
    //     this.features1 = this.inputAttrList1.length
    //   }else{
    //     this.features1 = this.attributes1.length
    //   }
    //   }).catch((err)=>{

    //   })
    //   return
    // }
  },
  beforeMount(){
    // this.getInputAttrListed1Fun
  },
  mounted () {
    this.getUserDetailsAgainFun
    // this.getInputAttrListed1Fun
  },
  methods: {
    resetFieldFun1(){
      this.uploadFileName1 = '';
      this.patient_name1 = '';
      this.first_name1 = '';
      this.last_name1 = '';
      this.patient_age1 = '';
      this.patient_gender1 = '';
      this.patient_id1 = '';
      this.patient_date1 = '';
      for(var i = 0; i < this.attributes1.length; i++){
        this.attributes1[i].forecast_val = ''
      }
      this.$validator.reset();
    },
    handleFileUpload1(event) {
      console.log("Second Task Upload File", event)
      if (event.target.files && event.target.files.length > 0) {
        this.file1 = event.target.files[0];
        this.files1 = this.$refs.file1.files[0];
        this.filesSize1 = this.$refs.file1.files[0].size;
        this.uploadFileName1 = this.files1.name
      }  else {
        this.uploadFileName1 = '';
      }
    },
    validateFileBeforeSubmit1(e) {
      $(window).scrollTop(0);
      this.my_features_data1 = [],
      this.my_feature_label1 = {}
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.algorithm_loader1 = true
          this.submitted1 = true;
          this.resultData1 = ''
          this.uploadingLoader3 = true
          this.errMsgShow1 = false
          this.errMsg1 = ''
          let formData = new FormData();
          formData.append('name', this.task1);
          formData.append('patient_name', this.first_name1 + ' ' + this.last_name1);
          formData.append('patient_age', this.patient_age1);
          formData.append('patient_gender', this.patient_gender1);
          formData.append('patient_id', this.patient_id1);
          formData.append('patient_date', this.patient_date1);
          formData.append('task_number', 2);
          if(this.filetype1 == 'PSMWEIGHT'){
            formData.append('algorithm_name', 'Deep Learning');
          }else if(this.filetype1 == 'KNN'){
            formData.append('algorithm_name', 'k Nearest Neighbor');
          }else if(this.filetype1 == 'PSM'){
            formData.append('algorithm_name', 'kNN with PSM');
          }else if(this.filetype1 == 'SVM'){
            formData.append('algorithm_name', 'Support Vector Machine');
          }else if(this.filetype1 == 'NB'){
            formData.append('algorithm_name', 'Naive Bayes');
          }else if(this.filetype1 == 'RF'){
            formData.append('algorithm_name', 'Random Forest');
          }else if(this.filetype1 == 'DTREE'){
            formData.append('algorithm_name', 'Decision Tree');
          }
          formData.append('data_file', this.file1);
          formData.append('no_of_features', this.features1);
          if(this.inputAttrList1.length >= 1){
            for(var i = 0; i < this.inputAttrList1.length; i++){
                this.my_features_data1.push([this.inputAttrList1[i].forecast_val])
            }
          }else{
            for(var i = 0; i < this.attributes1.length; i++){
              this.my_features_data1.push([this.attributes1[i].forecast_val])
            }
          }
          console.log(this.inputAttrList1.length, this.attributes1.length, "features value check")
          formData.append('features', this.my_features_data1);
          if(this.inputAttrList1.length >= 1){
          Object.keys(this.inputAttrList1).map((index) => {
            this.my_feature_label1['x' + (parseInt(index) + 1) ] = this.inputAttrList1[index].value
          });
        }
        else{
          Object.keys(this.attributes1).map((index) => {
            this.my_feature_label1['x' + (parseInt(index) + 1) ] = this.attributes1[index].forecast_label
          });}
          formData.append('input_attributes', JSON.stringify(this.my_feature_label1));
            // if(this.filetype1 == 'PSMWEIGHT'){
            //   this.$store.dispatch('createKnnPsmWeightedDataFun', formData)
            //   .then((res) => {
            //     if (res.status == '200') {
            //       setTimeout(()=>{
            //         this.algorithm_loader1 = false
            //         this.resultData1 = res.data
            //         this.uploadingLoader3 = false
            //       },8000)
            //     }
            //   })
            //   .catch((err) => {
            //     setTimeout(()=>{
            //     this.errMsgShow1 = true
            //     this.errMsg1 = err.data
            //     this.uploadingLoader3 = false
            //     this.algorithm_loader1 = false
            //   },8000)
            //   })
            // } 
            if(this.filetype1 == 'KNN'){
              this.$store.dispatch('createKnnDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader1 = false
                    this.resultData1 = res.data
                    this.uploadingLoader3 = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                  this.errMsgShow1 = true
                  this.errMsg1 = err.data
                  this.uploadingLoader3 = false
                  this.algorithm_loader1 = false
              },8000)
              })
            }else if(this.filetype1 == 'PSM'){
              this.$store.dispatch('createKnnPsmDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader1 = false
                    this.resultData1 = res.data
                    this.uploadingLoader3 = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow1 = true
                this.errMsg1 = err.data
                this.uploadingLoader3 = false
                this.algorithm_loader1 = false
              },8000)
              })
            }else if(this.filetype1 == 'ANN'){
              this.$store.dispatch('createAnnDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader1 = false
                    this.resultData1 = res.data
                    this.uploadingLoader3 = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow1 = true
                this.errMsg1 = err.data
                this.uploadingLoader3 = false
                this.algorithm_loader1 = false
              },8000)
              })
            }else if(this.filetype1 == 'SVM'){
              this.$store.dispatch('createSvmDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader1 = false
                    this.resultData1 = res.data
                    this.uploadingLoader3 = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow1 = true
                this.errMsg1 = err.data
                this.uploadingLoader3 = false
                this.algorithm_loader1 = false
              },8000)
              })
            }else if(this.filetype1 == 'NB'){
              this.$store.dispatch('createNbDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader1 = false
                    this.resultData1 = res.data
                    this.uploadingLoader3 = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow1 = true
                this.errMsg1 = err.data
                this.uploadingLoader3 = false
                this.algorithm_loader1 = false
              },8000)
              })
            }else if(this.filetype1 == 'RF'){
              this.$store.dispatch('createRandomForestDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader1 = false
                    this.resultData1 = res.data
                    this.uploadingLoader3 = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow1 = true
                this.errMsg1 = err.data
                this.uploadingLoader3 = false
                this.algorithm_loader1 = false
              },8000)
              })
            }else if(this.filetype1 == 'DTREE'){
              this.$store.dispatch('createDecisionTreeDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader1 = false
                    this.resultData1 = res.data
                    this.uploadingLoader3 = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow1 = true
                this.errMsg1 = err.data
                this.uploadingLoader3 = false
                this.algorithm_loader1 = false
              },8000)
              })
            }
          return
        }
      });
    },
    updateTask1() {
      this.taskEditAble1 = false
    },
    updatedTask1() {
      this.taskEditAble1 = true
    },
    addNewAttributes1 : function () {
      this.attributes1.push(Vue.util.extend({}, this.attribute))
      this.features1 = this.attributes1.length
    },
    addApiNewAttributes: function () {
      this.inputAttrList1.push(Vue.util.extend({}, this.local_Array1))
      this.features1 = this.inputAttrList1.length
    },
    removeApiAttributes : function (index) {
      Vue.delete(this.inputAttrList1, index);
      this.features1 = this.inputAttrList1.length
    },
    removeAttributes1 : function (index) {
      Vue.delete(this.attributes1, index);
      this.features1 = this.attributes1.length
    },
    updateAttributes1(index){
      $('.updateAttributes' + index).addClass('d-none')
      $('.updatedAttributes' + index).removeClass('d-none')
    },
    updatedAttributes1(index){
      $('.updateAttributes' + index).removeClass('d-none')
      $('.updatedAttributes' + index).addClass('d-none')
    }
  },
  watch:{
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    }
    // getInputAttrListed1Fun() {
    //   this.$store.dispatch('getInputAttrListFun',{id:2}).then((res) => {
    //   this.inputAttrList1 = this.$store.getters.getInputAttrListGetters.data
    //   if(this.inputAttrList1 && this.inputAttrList1.length >= 1){
    //     this.features1 = this.inputAttrList1.length
    //   }else{
    //     this.features1 = this.attributes1.length
    //   }
    //   }).catch((err)=>{
        
    //   })
    //   return
    // }
  },
}